// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__nOgPt","svg_loader":"Loader_svg_loader__FAJ6v"};